<template>
    <section id="app-sidebar-section" class="uk-section uk-section-small uk-section-muted uk-height-1-1 uk-overflow-auto">
        <div id="app-sidebar" class="uk-container uk-height-1-1 uk-flex">
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            //
        }
    },
};
</script>

<style>
#app-sidebar-section {
    border-left: solid 1px rgba(0, 0, 0, 0.05);
}
</style>
